// This is common to all documentation pages

import gl from '@/DocGlossaryLink.vue';
import qs from '@/DocQuickStartLink.vue';
import faq from '@/DocFAQLink.vue';
import docAppBar from '@/DocAppBar.vue';
import linkTarget from '@/DocLinkTarget.vue';
import showMe from '@/DocShowMe.vue';
import gpxPlanner from '@/DocGPXPlanner.vue';
import h2link from '@/DocHowToLink.vue';
import { Styles } from './Styles';

function scrollFix(tgt: string) {
    if (tgt !== "#top") {
        const el = document.querySelector(tgt);
        if (el) el.scrollIntoView(true);
        window.scrollBy(0,60); // distance 60px is just trial & error
    }
}

export default function docPage(pageName: string) {
    return {
        name: pageName,
        components: {
            gl,
            qs,
            faq,
            h2link,
            docAppBar,
            linkTarget,
            showMe,
            gpxPlanner
        },
        data: () => ({
            defaultRouteColour: Styles.DefaultRouteColour,
            defaultTrackColour: Styles.DefaultTrackColour    
        }),
        mounted: function() {
           // Links *into* #anchors on this page don't work without correcting the scroll. 
            // This isn't an elegant workaround, but I don't have a better answer.
            if(location.hash) {
                const tgt = String(location.hash);
                setTimeout(() => scrollFix(tgt), 0.5);
            }
        }
    }
}

